import React from "react"
import { Grid, Typography } from "@material-ui/core"
import Skeleton from "@material-ui/lab/Skeleton"
import { makeStyles } from "@material-ui/core/styles"
import Case from "./Case"

const useStyles = makeStyles((theme) => ({
	card: {
		maxWidth: 345,
		margin: theme.spacing(2),
	},
	media: {
		height: 190,
	},
	typography: {
		width: "100%",
		textAlign: "center",
	},
}))

const CaseList = ({ list, isLoading }) => {
	const classes = useStyles()

	return (
		<Grid container spacing={3} className="case-list">
			{isLoading ? (
				<>
					{Array(9)
						.fill()
						.map((data, i) => (
							<Grid key={i} item xs={12} sm={6} lg={4} xl={4}>
								<Skeleton key={i} animation="wave" variant="rect" className={classes.media} />
							</Grid>
						))}
				</>
			) : (
				<>
					{list.length === 0 ? (
						<>
							<Typography className={classes.typography}>No data found!</Typography>
						</>
					) : (
						<>
							{list.map((data) => (
								<Grid key={data.case_id} item xs={12} sm={6} lg={4} xl={4}>
									<Case data={data} />
								</Grid>
							))}
						</>
					)}
				</>
			)}
		</Grid>
	)
}

export default CaseList
